export default function CandidateWarningIco() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="3.75" fill="#FEEFC6" />
      <path
        d="M12.0003 14H12.007M12.0003 12V9.99998M7.32167 16.6666H16.6789C17.708 16.6666 18.3492 15.5504 17.8306 14.6615L13.152 6.641C12.6375 5.75899 11.3631 5.75899 10.8486 6.641L6.16997 14.6615C5.65145 15.5504 6.29261 16.6666 7.32167 16.6666Z"
        stroke="#DC6803"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
